import jrMySearchesStatementTemplate from '../../view/angular/pages/my-searches-statement.tpl.html';

angular
  .module('jrMySearches', ['jrConfig'])
  .value('jrMySearchesStatementTemplate', jrMySearchesStatementTemplate)
  .controller('MySearchesCtrl', [
    'SearchDistanceConfig',
    'SearchOptionsService',
    'MySearchesConfig',
    'MySearchesResource',
    'MySearchesService',
    '$scope',
    'Messages',
    function (
      SearchDistanceConfig,
      SearchOptionsService,
      MySearchesConfig,
      MySearchesResource,
      MySearchesService,
      $scope,
      Messages
    ) {
      $scope.messages = Messages;
      $scope.autoDistanceText = SearchDistanceConfig.autoDistanceText;
      $scope.distanceFilterEnabled = SearchDistanceConfig.enabled;
      $scope.addStatementOpened = false;
      $scope.statementError = false;
      $scope.hasStatements = function () {
        return $scope.statements.length > 0;
      };
      $scope.openAddStatement = function () {
        $scope.addStatementOpened = !$scope.addStatementOpened;
        $scope.statementError = false;
      };
      $scope.addNewStatement = function (event, statement) {
        MySearchesResource.addStatement(statement).then(function (response) {
          if (response.data !== 'false') {
            const newStatement = [
              response.data.what,
              response.data.where,
              response.data.radiusValue,
            ].join(',');
            dataLayer.push({
              event: 'mysearches.add',
              newStatement,
            });
            MySearchesService.addStatement(
              MySearchesService.decorateStatementWithDistance(response.data)
            );
            $scope.addStatementOpened = false;
            $scope.newStatement = {
              what: '',
              where: '',
              distance: SearchOptionsService.findDistance(),
              distances: SearchOptionsService.distances,
            };
          } else {
            $scope.statementError = true;
          }
        });
        event.preventDefault();
      };
      $scope.newStatement = {
        what: '',
        where: '',
        distance: SearchOptionsService.findDistance(),
        distances: SearchOptionsService.distances,
      };

      $scope.$watch(
        function () {
          return MySearchesService.statements;
        },
        function (statements) {
          $scope.statements = angular.copy(statements);
          $scope.canAddStatement = $scope.statements.length < MySearchesConfig.maxUserStatements;
        },
        true
      );
    },
  ])
  .directive('jrMySearchesStatement', [
    'MySearchesService',
    'MySearchesResource',
    'SearchDistanceConfig',
    'jrMySearchesStatementTemplate',
    function (
      MySearchesService,
      MySearchesResource,
      SearchDistanceConfig,
      jrMySearchesStatementTemplate
    ) {
      return {
        scope: true,
        restrict: 'AE',
        replace: true,
        template: jrMySearchesStatementTemplate,
        link(scope, element, attrs) {
          scope.isNew = scope.$eval(attrs.isNew) || false;
          scope.isEditing = scope.isNew;
          scope.statementError = false;
          scope.showDistanceInLocation = SearchDistanceConfig.enabled && jrConfigGlobal.isMobile;
          scope.deleteConfirmationVisible = false;

          scope.addStatement = function (event) {
            MySearchesResource.addStatement(scope.statement).then(function (response) {
              MySearchesService.addStatement(
                MySearchesService.decorateStatementWithDistance(response.data)
              );
            });
            event.preventDefault();
          };
          scope.editStatement = function (event) {
            scope.initialStatement = angular.copy(scope.statement);
            scope.isEditing = true;
            scope.focusInput = true;
            scope.statementError = false;
            event.preventDefault();
          };
          scope.resetStatement = function (event) {
            scope.statement = scope.initialStatement;
            scope.isEditing = false;
            event.preventDefault();
          };
          scope.saveStatement = function (event, index) {
            if (scope.statement.what === '' && scope.statement.where === '') {
              scope.statementError = true;
              event.preventDefault();
              return;
            }
            MySearchesResource.saveStatement(scope.statement, index).then(function (response) {
              const statement = MySearchesService.statements[index];
              const oldStatement = [statement.what, statement.where, statement.radiusValue].join(
                ','
              );
              const newStatement = [
                response.data.what,
                response.data.where,
                response.data.radiusValue,
              ].join(',');
              if (newStatement !== oldStatement) {
                dataLayer.push({
                  event: 'mysearches.edit',
                  newStatement,
                  oldStatement,
                });
                MySearchesService.saveStatement(
                  MySearchesService.decorateStatementWithDistance(response.data),
                  index
                );
              }
            });
            event.preventDefault();
          };
          scope.deleteStatement = function (event, index, redirect) {
            event.preventDefault();
            MySearchesResource.deleteStatement(index).then(function (response) {
              const statement = MySearchesService.statements[index];
              const oldStatement = [statement.what, statement.where, statement.radiusValue].join(
                ','
              );
              dataLayer.push({
                event: 'mysearches.delete',
                oldStatement,
              });
              if (redirect === true) {
                location.href = event.target.parentElement.href;
              } else {
                MySearchesService.deleteStatement(index);
              }
            });
          };
        },
      };
    },
  ])
  .directive('jrFocusInput', [
    '$timeout',
    function ($timeout) {
      return {
        scope: { trigger: '=jrFocusInput' },
        link(scope, element) {
          scope.$watch('trigger', function (value) {
            if (value) {
              element[0].focus();
              scope.trigger = false;
            }
          });
        },
      };
    },
  ]);
